import { useState } from 'react';
import {
  Box, Typography, TextField, Button, Table, TableHead,
  TableBody, TableRow, TableCell
} from '@mui/material';
import axios from 'axios';

const API = 'https://attend.zventures.in';

const LocationManagement = ({ locations, setLocations }) => {
  const [name, setName] = useState('');

  const addLocation = async () => {
    if (!name.trim()) return;
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/api/locations`, { name: name.trim() }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLocations(prev => [...prev, res.data]);
      setName('');
    } catch (err) {
      console.error('Error adding location:', err);
    }
  };

  const removeLocation = async (locName) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/api/locations/${encodeURIComponent(locName)}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLocations(prev => prev.filter(l => l.name !== locName));
    } catch (err) {
      console.error('Error removing location:', err);
    }
  };

  return (
    <Box sx={{ background: 'linear-gradient(to bottom right,#e6f0f9,#e6f0f9)', borderRadius: '10px', p: 3, mb: '5%' }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 400 }}>Admin Panel – Manage Locations</Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <TextField
          label="Location Name"
          value={name}
          onChange={e => setName(e.target.value)}
          InputProps={{ sx: { backgroundColor: 'white' } }}
        />
        <Button variant="contained" onClick={addLocation}>Add Location</Button>
      </Box>

      <Box sx={{ borderRadius: 2, backgroundColor: '#ffffffcc', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 300, color: '#1e3a8a' }}>Location List</Typography>
        <Table>
          <TableHead>
            <TableRow sx={{ background: '#f0f4ff' }}>
              <TableCell><strong>Location Name</strong></TableCell>
              <TableCell><strong>Action</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {locations.length === 0 ? (
              <TableRow><TableCell colSpan={2} align="center">No locations added yet</TableCell></TableRow>
            ) : locations.map(loc => (
              <TableRow key={loc.name}>
                <TableCell>{loc.name}</TableCell>
                <TableCell>
                  <Button color="error" variant="outlined" size="small" onClick={() => removeLocation(loc.name)}>
                    Remove
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default LocationManagement;